export default "__VITE_ASSET__BjJLGvWj__"